import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import { observer } from 'mobx-react-lite';

import {
    Colours,
    ExperimentSegments,
    IconGift,
    useExperiment,
    EXPERIMENTS,
    GIFT_OFFER_BANNER_COLOURS,
} from '@ratehub/base-ui';

import CreditCardSynopsisShape from '../definitions/CreditCardSynopsisShape';
import getGiftOfferSummary from '../functions/getGiftOfferSummary';


function CardLayoutBanner({ giftCardOffer, isCompact = false, className }) {
    const intl = useIntl();
    const isDarkerOffers = useExperiment(EXPERIMENTS.darkerOffers).segment === ExperimentSegments.VARIANT_1;

    const bannerColours = GIFT_OFFER_BANNER_COLOURS[isDarkerOffers ? 1 : 0];

    // as of now, this is restricted to only showing the gift card offer
    return (
        <div
            className={classNames(className, 'rh-m-0 rh-px-2', bannerColours.background, {
                isCompact: isCompact,
                'rh-py-0': isCompact,       // removes vertical padding around text
                'rh-py-0_25': !isCompact,
            })}
            data-test-name="card-layout-banner"
        >
            <span
                className={classNames(
                    'banner-text rh-display-flex rh-align-items-center rh-justify-content-center',
                    'rh-text-xs rh-mx-auto rh-my-0'
                )}
            >
                <IconGift
                    className="rh-icon-xs rh-mr-0_25 rh-flex-shrink-0"
                    outlineWidth="0"
                    stroke={Colours.GRAPE_DARK}
                    fill={bannerColours.iconFill}
                />

                <span className={classNames('rh-my-0_25', bannerColours.textColour)}>
                    {getGiftOfferSummary({ giftCardOffer, intl })}
                </span>
            </span>
        </div>
    );
}

CardLayoutBanner.propTypes = {
    giftCardOffer: CreditCardSynopsisShape.giftCardOffer.isRequired,
    isCompact: PropTypes.bool,
    className: PropTypes.string,
};


export default styled(observer(CardLayoutBanner))`
    // when 4px to match container, there was a noticeable gap between the border of the outer container
    // and the background colour of this component
    border-radius: 3px 3px 0 0;         // must (nearly) match that of container
    &.isCompact {
        border-radius: 1px 1px 0 0;     // we expect there’s no need for arbitrary border-radius; offering these two choices
    }

    > .banner-text {
        max-width: 85%;
    }
`;
